import { create } from 'zustand';

import { createSentChatRepliesSlice } from './actions';
import { SentChatRepliesByMessageId, SentChatRepliesStore } from './types';

export const useSentChatRepliesStore = create<SentChatRepliesStore>()(
  (set, get, store) => ({
    ...createSentChatRepliesSlice(set, get, store),
  }),
);

export const useSentChatReplies = (
  inboxEntryId: string,
): SentChatRepliesByMessageId | undefined =>
  useSentChatRepliesStore((state) => state.byEntryId[inboxEntryId]);
